module.exports = __webpack_public_path__ + "static/media/Search_Small_Icon.3bd9a596.svg";